import React from 'react';
import { useTranslation } from 'react-i18next';
import { TeamMember } from '../types';
import './About.css';

const About: React.FC = () => {
  const { t } = useTranslation();
  

  const teamMembers: TeamMember[] = [
    {
      id: '1',
      name: t('about.team.rotaryClub.name'),
      role: t('about.team.rotaryClub.role'),
      bio: t('about.team.rotaryClub.bio'),
      image: '/Rotary Club Peja Logo.png'
    },
    {
      id: '2',
      name: t('about.team.university.name'),
      role: t('about.team.university.role'),
      bio: t('about.team.university.bio'),
      image: '/Haxhi Zeka Logo.png'
    },
    {
      id: '3',
      name: t('about.team.organizingCommittee.name'),
      role: t('about.team.organizingCommittee.role'),
      bio: t('about.team.organizingCommittee.bio'),
      image: null,
      buttonText: t('about.team.meetTeam'),
      buttonLink: '/team'
    },
    {
      id: '4',
      name: t('about.team.advisoryBoard.name'),
      role: t('about.team.advisoryBoard.role'),
      bio: t('about.team.advisoryBoard.bio'),
      image: null,
      buttonText: t('common.learnMore'),
      buttonLink: '/advisory-board'
    }
  ];

  return (
    <div className="about">
      {/* Hero Section */}
      <section className="about-hero section">
        <div className="container">
          <div className="about-hero-content text-center">
            <h1>{t('about.hero.title')}</h1>
            <p className="hero-subtitle">
              {t('about.hero.subtitle')}
            </p>
          </div>
        </div>
      </section>

      {/* Mission & Vision Section */}
      <section className="mission-vision section">
        <div className="container">
          <div className="mv-grid">
            <div className="mv-card">
              <h3>{t('about.mission.title')}</h3>
              <p>
                {t('about.mission.description')}
              </p>
            </div>
            <div className="mv-card">
              <h3>{t('about.vision.title')}</h3>
              <p>
                {t('about.vision.description')}
              </p>
            </div>
            <div className="mv-card">
              <h3>{t('about.values.title')}</h3>
              <p>
                {t('about.values.description')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* History Section */}
      <section className="history section">
        <div className="container">
          <div className="history-content">
            <div className="history-text">
              <h2>{t('about.history.title')}</h2>
              <p>
                {t('about.history.description1')}
              </p>
              <p>
                {t('about.history.description2')}
              </p>
              <p>
                {t('about.history.description3')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Founder Section */}
      <section className="founder section">
        <div className="container">
          <div className="founder-content">
            <div className="founder-image">
              <img src="/Neshad Albani Founder Picture.jpg" alt="Dr. Neshad R. Albani, Founder of Peja Peace Forum" />
            </div>
            <div className="founder-text">
              <h2>{t('about.founder.title')}</h2>
              <h3 className="founder-name">Dr. Neshad R. Albani</h3>
              <p className="founder-subtitle">{t('about.founder.subtitle')}</p>
              <div className="founder-bio">
                <p>{t('about.founder.bio1')}</p>
                <p>{t('about.founder.bio2')}</p>
                <p>{t('about.founder.bio3')}</p>
                <p>{t('about.founder.bio4')}</p>
                <p>{t('about.founder.bio5')}</p>
                <p>{t('about.founder.bio6')}</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section */}
      <section className="team section">
        <div className="container">
          <h2 className="text-center">{t('about.team.title')}</h2>
          <p className="team-intro text-center">
            {t('about.team.subtitle')}
          </p>
          <div className="team-grid about-team-grid">
            {teamMembers.map((member) => (
              <div key={member.id} className="team-card">
                {member.image && (
                  <div className="team-image">
                    <img 
                      src={member.image} 
                      alt={member.name}
                      onError={(e) => {
                        e.currentTarget.src = '/images/placeholder-avatar.png';
                      }}
                    />
                  </div>
                )}
                <div className="team-info">
                  <h3 className="team-name">{member.name}</h3>
                  <p className="team-role">{member.role}</p>
                  <p className="team-bio">{member.bio}</p>
                  {member.buttonText && member.buttonLink && (
                    <a href={member.buttonLink} className="team-button">
                      {member.buttonText}
                    </a>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Impact Section */}
      <section className="impact section">
        <div className="container">
          <h2 className="text-center">{t('impact.title')}</h2>
          <div className="impact-stats">
            <div className="stat-item">
              <div className="stat-number">{t('impact.firstEdition.number')}</div>
              <div className="stat-label">{t('impact.firstEdition.label')}</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{t('impact.participants.number')}</div>
              <div className="stat-label">{t('impact.participants.label')}</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{t('impact.partners.number')}</div>
              <div className="stat-label">{t('impact.partners.label')}</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">{t('impact.globalReach.number')}</div>
              <div className="stat-label">{t('impact.globalReach.label')}</div>
            </div>
          </div>
        </div>
      </section>

    </div>
  );
};

export default About;
